<template>
  <Layout>
    <Header :logo="logo" :title="lang(title)" />
    <Layout>
      <Sider>
        <LayoutMenu />
      </Sider>
      <LayoutContent class="layout-content">
        <Tabs />
        <div class="page-wrap">
          <router-view v-slot="{ Component }">
            <keep-alive :include="VITE_APP_ENV !== 'development' ? keepAliveComponentNames : []">
              <component :is="Component" :key="$route.fullPath"></component>
            </keep-alive>
          </router-view>
        </div>
      </LayoutContent>
    </Layout>
  </Layout>
</template>

<script lang="ts" setup>
  import { computed, KeepAlive } from 'vue'
  import { Layout, LayoutContent } from 'ant-design-vue'
  import LayoutMenu from './menu/Index.vue'
  import Header from './header/Index.vue'
  import Sider from './sider/Index.vue'
  import Tabs from './tabs/Index.vue'
  import { useTabStore } from '@jms/store'
  import { lang } from '@jms/utils'

  defineProps({
    logo: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  })

  const { VITE_APP_ENV } = import.meta.env
  const tabStore = useTabStore()
  const keepAliveComponentNames = computed(() => tabStore.getTabs.map((_) => _.name))
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
